<template>
  <div class="steps bg-black-gray3">
    <div class="title color-black-gray1">報名流程</div>
    <div class="content">
      <div class="row" v-if="isStop">
        <p style="font-weight: bold">
          第十六屆 DFC 挑戰收件完畢！<br />
          挑戰平台優化中，預計於八月底開放！第十七屆 DFC 挑戰見囉！<br />
          DFC 挑戰最新消息會發布於官方網站、Facebook、Instagram，敬請期待！<br />
          若有問題，歡迎透過以下方式與我們聯繫：<br /><br />
          臺灣童心創意行動協會（DFC臺灣）<br />
          時間｜10:00-18:00<br />
          電話｜02-2368-1310<br />
          官方 LINE ｜@801cukmv
        </p>
      </div>
      <div class="row" v-else>
        <div class="step step1">
          <div class="step-head row layout-align-center">
            <div class="step-icon">
              <div class="step-text">1</div>
            </div>
            <div class="step-line"></div>
          </div>
          <div class="title">成立小組</div>
          <div class="description layout-column color-text1">
            <div>1.1 填寫小組成員資訊</div>
            <div>1.2 加入其他輔導員夥伴（選填）</div>
          </div>
          <br />
          <div class="button-box layout-column">
            <div class="download">
              <div class="text color-text3">
                *內含：DFC 挑戰簡章、DFC 挑戰學習單、DFC
                挑戰學習單範例、故事資料授權暨家長同意書樣本......等，任何您報名挑戰會需要用到的文件。
              </div>
              <a
                class="button button-tp color-white bg-blue1 layout-row layout-hv-center pointer"
                href="https://drive.google.com/drive/folders/1VTS_imZtYIOFzsSGfWf1x4KIsE6K-Qjk?usp=sharing"
                target="_blank"
                >下載 DFC 挑戰資源包</a
              >
            </div>
          </div>
        </div>
        <div class="step step2">
          <div class="step-head row layout-align-center">
            <div class="step-icon">
              <div class="step-text">2</div>
            </div>
            <div class="step-line"></div>
          </div>
          <div class="title">進行 DFC 四階段</div>
          <div class="description layout-column color-text1">
            <b>填寫 / 上傳 DFC 挑戰資料：</b>
            <div>2.1 填寫感受到的問題</div>
            <div>2.2 以照片分享歷程：上傳 DFC 四階段照片</div>
            <div>2.3 以文字分享歷程：上傳 DFC 挑戰學習單</div>
            <div>2.4 故事資料授權暨家長同意書</div>
            <div>2.5 報名參加 DFC 挑戰分享季</div>
            <div>2.6 上傳 DFC 挑戰故事影片</div>
            <div>2.7 勾選符合的 SDGs 項目</div>
          </div>
        </div>
        <div class="step step3">
          <div class="step-head row layout-align-center">
            <div class="step-icon">
              <div class="step-text">3</div>
            </div>
            <div class="step-line"></div>
          </div>
          <div class="title">小組成員基本資料填寫</div>
          <div class="description layout-column">
            <div>3.1 填寫國際證書資料</div>
            <div>3.2 填寫輔導員問卷</div>
            <div>3.3 學生填寫自評表</div>
          </div>
        </div>
        <div class="step step4">
          <div class="step-head row layout-align-center">
            <div class="step-icon">
              <div class="step-text">4</div>
            </div>
          </div>
          <div class="title">完成 DFC 挑戰</div>
          <div class="description layout-column">
            <div>4.1 確認故事資料</div>
            <div>4.2 按下「送出故事資料」</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isStop: Boolean,
  },
  data() {
    return {
      videoKnow: false,
      descriptionTip: false,
    };
  },
  computed: {},
  methods: {},
  created() {},
  mounted() {},
  components: {},
};
</script>

<style lang="scss" scoped>
.steps {
  padding: 18px 17px 50px 17px;
  position: relative;

  .title {
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 30px;
  }

  .content {
    .step-head {
      .step-icon {
        border-radius: 50%;
        border: 2px solid;
        border-color: inherit;
        position: relative;
        z-index: 1;
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        width: 24px;
        height: 24px;
        font-size: 14px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        background: #fff;
        -webkit-transition: 0.15s ease-out;
        transition: 0.15s ease-out;

        .step-text {
          display: inline-block;
          -webkit-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
          user-select: none;
          text-align: center;
          font-weight: 700;
          line-height: 1;
          color: inherit;
        }
      }

      .step-line {
        border: solid 1px #909399;
      }
    }

    .title {
      font-size: 14px;
      font-weight: 700;
      margin-top: 5px;
      margin-bottom: 10px;
    }

    .description {
      line-height: 1.5;
      font-size: 12px;
    }

    .descriptionTip {
      margin-top: 1px;
    }

    .video-know {
      width: 72px;
      border-bottom: 1px solid #60adf5;
      margin-top: 3px;
    }

    .step {
      &:not(:last-child) {
        .step-line {
          flex: 1;
        }
      }
    }

    .step1 {
      flex: 4.3;
    }

    .step2 {
      flex: 5;
    }

    .step3 {
      flex: 3;
    }
  }

  .button-box {
    justify-content: flex-end;
    margin-right: 15px;

    .button {
      border-radius: 5px;
      font-size: 18px;
      width: 100%;
      height: 30px;
      text-decoration: none;
      height: 35px;
    }

    .download {
      margin-bottom: 5px;
    }

    .text {
      font-size: 12px;
      max-width: 200px;
      margin-bottom: 15px;
      text-align: justify;
    }
  }
}
</style>
